import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Boxes } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/erp/ui";

const errText = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Terjadi kesalahan, coba lagi."; };

const Shell = ({ title, children }) => (
  <div className="min-h-screen flex items-center justify-center p-8 bg-slate-50">
    <div className="w-full max-w-sm anim-up">
      <div className="flex items-center gap-2 font-head font-bold text-xl mb-8"><Boxes className="text-sky-500" /> FOMU 3D PRINT</div>
      <h2 className="font-head text-2xl font-bold mb-6">{title}</h2>
      {children}
      <Link to="/login" data-testid="back-to-login" className="block text-center text-sm text-slate-500 mt-6 hover:text-slate-900">← Kembali ke halaman masuk</Link>
    </div>
  </div>
);

const btn = "w-full bg-slate-900 text-white rounded-xl py-3 font-medium hover:bg-slate-800 disabled:opacity-50";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); } catch (x) { setMsg(errText(x)); }
    setBusy(false);
  };
  return (
    <Shell title="Lupa Password">
      {msg ? <p data-testid="forgot-msg" className="text-sm text-slate-600 bg-white border border-slate-200 rounded-xl p-4">{msg}</p> : (
        <form onSubmit={submit} className="space-y-3">
          <p className="text-sm text-slate-500">Masukkan email akun Anda. Kami kirim link untuk membuat password baru.</p>
          <Input data-testid="forgot-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <button data-testid="forgot-submit" disabled={busy} className={btn}>{busy ? "Mengirim..." : "Kirim Link"}</button>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (f.password !== f.confirm) { setErr("Konfirmasi password tidak sama"); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: sp.get("token") || "", password: f.password }); nav("/login?reset=1", { replace: true }); } catch (x) { setErr(errText(x)); }
    setBusy(false);
  };
  return (
    <Shell title="Buat Password Baru">
      <form onSubmit={submit} className="space-y-3">
        <Input data-testid="reset-password" type="password" required minLength={6} placeholder="Password baru (min. 6 karakter)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
        <Input data-testid="reset-confirm" type="password" required placeholder="Ulangi password baru" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
        {err && <p data-testid="reset-error" className="text-sm text-rose-600">{err}</p>}
        <button data-testid="reset-submit" disabled={busy} className={btn}>{busy ? "Menyimpan..." : "Simpan Password"}</button>
      </form>
    </Shell>
  );
}
